<div class="dialog-container">
  <div class="dialog-header">
    <h2 mat-dialog-title>Charger Details</h2>
    <button mat-icon-button (click)="closeDialog()" aria-label="Close dialog">
      <mat-icon>close</mat-icon>
      <!-- Assuming MatIconModule is imported -->
    </button>
  </div>
  <mat-dialog-content>
    <!-- Existing Content Start -->

    <!-- Token Details Section -->
    <div
      class="token-details-section"
      *ngIf="tokenDetails?.length > 0 && !tokenContracts?.length"
    >
      <div class="token-title">Token Details</div>

      <div *ngIf="tokenDetailsLoading" class="loading-contracts">
        Loading token details...
      </div>

      <div *ngIf="tokenDetails && tokenDetails.length > 0">
        <!-- BID_AMOUNT Details -->
        <div
          *ngIf="getTokenDetailsByChargeType('BID_AMOUNT').length > 0"
          class="contract-type-section"
        >
          <div class="contract-type-title">Bid Amount</div>
          <div class="contracts-list">
            <div
              *ngFor="let token of getTokenDetailsByChargeType('BID_AMOUNT')"
              class="token-item"
            >
              <div class="token-details">
                <span class="token-amount"
                  >Amount: {{ formatNumber(+token.amount) }}</span
                >
              </div>
            </div>
          </div>
        </div>

        <!-- TRANSACTION_FEE Details -->
        <div
          *ngIf="getTokenDetailsByChargeType('TRANSACTION_FEE').length > 0"
          class="contract-type-section"
        >
          <div class="contract-type-title">Transaction Fee</div>
          <div class="contracts-list">
            <div
              *ngFor="
                let token of getTokenDetailsByChargeType('TRANSACTION_FEE')
              "
              class="token-item"
            >
              <div class="token-details">
                <span class="token-amount"
                  >Amount: {{ formatNumber(+token.amount) }}</span
                >
              </div>
            </div>
          </div>
        </div>

        <!-- PENALTY_HOLD Details -->
        <div
          *ngIf="getTokenDetailsByChargeType('PENALTY_HOLD').length > 0"
          class="contract-type-section"
        >
          <div class="contract-type-title">Collateral</div>
          <div class="contracts-list">
            <div
              *ngFor="let token of getTokenDetailsByChargeType('PENALTY_HOLD')"
              class="token-item"
            >
              <div class="token-details">
                <span class="token-amount"
                  >Amount: {{ formatNumber(+token.amount) }}</span
                >
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Token Contracts Section -->
    <div class="token-contracts-section" *ngIf="tokenContracts?.length > 0">
      <div class="token-title">Token Contracts</div>

      <div *ngIf="tokenContractsLoading" class="loading-contracts">
        Loading token contracts...
      </div>

      <!-- BID_AMOUNT Contracts -->
      <div
        *ngIf="getContractsByType('BID_AMOUNT').length > 0"
        class="contract-type-section"
      >
        <div class="contract-type-title">Bid Amount</div>
        <div class="contracts-list">
          <div
            *ngFor="let contract of getContractsByType('BID_AMOUNT')"
            class="contract-item"
          >
            <div class="contract-details">
              <span class="contract-amount"
                >Amount: {{ formatNumber(+contract.amount) }}</span
              >
              <span class="contract-status">Status: {{ contract.status }}</span>
            </div>
          </div>
        </div>
      </div>

      <!-- TRANSACTION_FEE Contracts -->
      <div
        *ngIf="getContractsByType('TRANSACTION_FEE').length > 0"
        class="contract-type-section"
      >
        <div class="contract-type-title">Transaction Fee</div>
        <div class="contracts-list">
          <div
            *ngFor="let contract of getContractsByType('TRANSACTION_FEE')"
            class="contract-item"
          >
            <div class="contract-details">
              <span class="contract-amount"
                >Amount: {{ formatNumber(+contract.amount) }}</span
              >
              <span class="contract-status">Status: {{ contract.status }}</span>
            </div>
          </div>
        </div>
      </div>

      <!-- PENALTY_HOLD Contracts -->
      <div
        *ngIf="getContractsByType('PENALTY_HOLD').length > 0"
        class="contract-type-section"
      >
        <div class="contract-type-title">Collateral</div>
        <div class="contracts-list">
          <div
            *ngFor="let contract of getContractsByType('PENALTY_HOLD')"
            class="contract-item"
          >
            <div class="contract-details">
              <span class="contract-amount"
                >Amount: {{ formatNumber(+contract.amount) }}</span
              >
              <span class="contract-status">Status: {{ contract.status }}</span>
            </div>
          </div>
        </div>
      </div>

      <!-- Other Contract Types -->
      <div *ngFor="let type of ['OTHER']">
        <div
          *ngIf="getContractsByType(type).length > 0"
          class="contract-type-section"
        >
          <div class="contract-type-title">{{ type }}</div>
          <div class="contracts-list">
            <div
              *ngFor="let contract of getContractsByType(type)"
              class="contract-item"
            >
              <div class="contract-details">
                <span class="contract-amount"
                  >Amount: {{ formatNumber(+contract.amount) }}</span
                >
                <span class="contract-status"
                  >Status: {{ contract.status }}</span
                >
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Existing Content End -->
  </mat-dialog-content>
  <!-- Removed mat-dialog-actions block -->
</div>
